import React from 'react'

import { ArticleList } from '@components/common/ArticleList'
import { SectionTitle } from '@modules/Dashboard/Home/components/SectionTitle'

import { membershipsStrategiesArticle, perksGuideArticle } from '../../../../consts'

export const Articles = () => (
  <div style={{ marginTop: 48 }}>
    <SectionTitle title="Need some ideas? Check out these helpful resources" />
    <ArticleList items={[membershipsStrategiesArticle, perksGuideArticle]} />
  </div>
)
